/**************
 Cart
 ***************/

// product ID's
const bundleProductVariantID = 46235113619712;
const pottyTrainingVariantID = 46170968195328;
const winningToddlerStageVariantID = 46168723390720;
const pottyChallengeVariantID = 46576023535872;
const bigFeelersProductVariantID = 46728248361216;
const bigFeelersWTTSBundleProductVariantID = 46736580837632;
const PTMSChallengeBundleVariantID = 46576035397888
const PTMSChallengeBundleProductID = 9068505530624

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }


    // get cart item data
    let cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    let variantIDToSellingPlanName = cartData.variantIDToSellingPlanName;
    let variantIDToSellingPlanID = cartData.variantIDToSellingPlanID;
    let variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;
    let variantIDToMaxQty = cartData.variantIDToMaxQty;

    // check for max item quantity
    // limits digital courses to 1 per customer
    let maxItemQty = 1;
    let updatePayload = {};
    cart.items.forEach(item => {
        if (item.quantity > maxItemQty && variantIDToMaxQty[item.variant_id] === "true") {
            updatePayload[item.key] = 1;
        }
    });

    // check if both the potty training course AND the winning toddler stage course are in the cart
    let pottyTrainingCourseInCart = cart.items.find(item => item.variant_id === pottyTrainingVariantID);
    let winningToddlerStageCourseInCart = cart.items.find(item => item.variant_id === winningToddlerStageVariantID);
    let bundleProductInCart = cart.items.find(item => item.variant_id === bundleProductVariantID);
    let PTMSChallengeBundleInCart = cart.items.find(item => item.variant_id === PTMSChallengeBundleVariantID);


    // if both courses are in the cart, add the bundle product and remove the two courses
    if (pottyTrainingCourseInCart && winningToddlerStageCourseInCart) {
        cart.items.forEach(item => {
            if (item.variant_id === pottyTrainingVariantID || item.variant_id === winningToddlerStageVariantID) {
                updatePayload[item.key] = 0;
            }
        });
        await addProduct({
            items: [{
                id: bundleProductVariantID,
                quantity: 1
            }]
        });
    }

    // check if both the WTTS course AND the Big Feelers course are in the cart
    let bigFeelersCourseInCart = cart.items.find(item => item.variant_id === bigFeelersProductVariantID);
    let bigFeelersWWTSProductInCart = cart.items.find(item => item.variant_id === bigFeelersWTTSBundleProductVariantID);

    // if both courses are in the cart, add the bundle product and remove the two courses
    if (bigFeelersCourseInCart && winningToddlerStageCourseInCart) {
        cart.items.forEach(item => {
            if (item.variant_id === bigFeelersProductVariantID || item.variant_id === winningToddlerStageVariantID) {
                updatePayload[item.key] = 0;
            }
        });
        await addProduct({
            items: [{
                id: bigFeelersWTTSBundleProductVariantID,
                quantity: 1
            }]
        });
    }


    // check if both the potty training course AND the potty challenge course are in the cart
    let pottyChallengeCourseInCart = cart.items.find(item => item.variant_id === pottyChallengeVariantID);
    if (pottyTrainingCourseInCart && pottyChallengeCourseInCart) {
        cart.items.forEach(item => {
            if (item.variant_id === pottyTrainingVariantID || item.variant_id === pottyChallengeVariantID) {
                updatePayload[item.key] = 0;
            }
        });
        await addProduct({
            items: [{
                id: PTMSChallengeBundleVariantID,
                quantity: 1
            }]
        });
    }

    // check if we need to update the cart
    if (Object.keys(updatePayload).length > 0) {
        cart = await updateCart({updates: updatePayload});
        await openCart(true);
        return;
    }


    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count
    document.querySelectorAll('.headerIconsCart').forEach(element => {
        element.setAttribute("data-count", cart.item_count);
    });
    document.querySelector("#miniCartHeaderTitleCountNum").textContent = `${cart.item_count}`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.add("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        document.querySelector("#miniCartCols").classList.remove("active");
        document.querySelectorAll('.miniCartUpsell').forEach(element => element.classList.remove("active"));
        document.querySelectorAll('.miniCartUpsell').forEach(element => element.classList.add("hidden"));
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");
    document.querySelector("#miniCartCols").classList.add("active");
    document.querySelectorAll('.miniCartUpsell').forEach(element => element.classList.remove("hidden"));

    document.querySelectorAll('.miniCartUpsell').forEach(element => element.classList.add("active"));


    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend<b> ${price(freeShippingThreshold - cart.total_price, true)}</b> more for <b>FREE SHIPPING</b>`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // skip if starts with a _
                if (key.startsWith("_")) {
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = price(item.final_line_price, true);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (variantIDToCompareAtPrice[item.variant_id]) {
                comparePrices.push(variantIDToCompareAtPrice[item.variant_id] * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    HTML += `
                        <s>${price(greatestComparePrice, true)}</s>
                    `;
                }
            }

            return HTML;
        }

        // discount HTML
        function discountHTML() {
            let HTML = "";

            // check for discount
            if (item.line_level_discount_allocations.length === 0) {
                return "";
            }

            item.line_level_discount_allocations.forEach(discount => {
                HTML = `<div class="miniCartBodyItemDiscount">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#EDE6D6CC"><path d="M856-390 570-104q-12 12-27 18t-30 6q-15 0-30-6t-27-18L103-457q-11-11-17-25.5T80-513v-287q0-33 23.5-56.5T160-880h287q16 0 31 6.5t26 17.5l352 353q12 12 17.5 27t5.5 30q0 15-5.5 29.5T856-390ZM513-160l286-286-353-354H160v286l353 354ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640Zm220 160Z"/></svg>
                        ${discount.discount_application.title}
                        </div>`;
            });


            return HTML;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <div class="miniCartBodyItemWrap">
                    <div class="miniCartBodyItemTitle">${item.product_title}</div>
                        ${variantHTML()}
                        ${propertiesHTML()}
                        ${subscriptionHTML()}
                        ${discountHTML()}
                </div>
                <div class="miniCartBodyItemControls">
                    <div class="miniCartBodyItemQuantity">
                        <button class="miniCartBodyItemQuantityMinus">-</button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus">+</button>
                    </div>
                    <button class="miniCartBodyItemRemove">
                        REMOVE
                    </button>
                </div>
                <div class="miniCartBodyItemPrice">${priceHTML()}</div>
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);
            const sellingPlanID = parseInt(this.dataset.plan);

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // add selling plan
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            await openCart(true);

            // remove loading animation
            this.classList.remove("loading");
        });
    });


    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);
        let variantID = parseInt(element.dataset.variant);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });


    // if the bundle is in the cart, don't show the upsells
    if (bundleProductInCart || bigFeelersWWTSProductInCart || PTMSChallengeBundleInCart) {
        document.querySelectorAll('.miniCartUpsell').forEach(function (element) {
            element.classList.remove("active");
        })
    }

    if (pottyTrainingCourseInCart) {
        // if PTMS in cart don't show big feelers upsell
        document.querySelectorAll('.miniCartUpsellItem').forEach(function (element) {
            if (parseInt(element.dataset.variant) === bigFeelersProductVariantID) {
                element.classList.remove("active");
            }
        })
    }

    // don't show more than 3 upsells on desktop
    if (window.innerWidth > 800) {
        let activeUpsells = document.querySelectorAll('.miniCartUpsellItem.active');

        activeUpsells.forEach(function (element, index) {
            if (index >= 3) {
                element.classList.remove("active");
            }
        })
    }

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelectorAll(".miniCartUpsell").forEach(element => element.classList.remove("active"));
    }


    document.querySelector("#miniCartFooterReceiptPrice").textContent = price(cart.items_subtotal_price, true);

}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartUpsellItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});


// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function () {
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));


// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}